<template>
  <h3 class="text-h5" style="white-space: wrap;">
    <slot />
  </h3>
</template>

<style lang="scss" scoped>
.headline {
  margin: 48px 0 16px;
  color: #000;
}
</style>
